import { authGuard, permissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./main/trip/trip.module').then(m => m.TripModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('@volo/abp.ng.account/public').then(m => m.AccountPublicModule.forLazy()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy()),
  },
  {
    path: 'language-management',
    loadChildren: () =>
      import('@volo/abp.ng.language-management').then(m => m.LanguageManagementModule.forLazy()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(m => m.SaasModule.forLazy()),
  },
  {
    path: 'audit-logs',
    loadChildren: () =>
      import('@volo/abp.ng.audit-logging').then(m => m.AuditLoggingModule.forLazy()),
  },
  {
    path: 'openiddict',
    loadChildren: () =>
      import('@volo/abp.ng.openiddictpro').then(m => m.OpeniddictproModule.forLazy()),
  },
  {
    path: 'text-template-management',
    loadChildren: () =>
      import('@volo/abp.ng.text-template-management').then(m =>
        m.TextTemplateManagementModule.forLazy()
      ),
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },
  {
    path: 'synchronization',
    loadChildren: () => import('./main/synchronization/synchronization.module').then(m => m.SynchronizationModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'trip-journey-reception',
    loadChildren: () => import('./main/trip-journey-reception/trip-journey-reception.module').then(m => m.TripJourneyReceptionModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'materials',
    loadChildren: () => import('./main/material-qualities/material-qualities.module').then(m => m.MaterialQualitiesModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'deposits-documents',
    loadChildren: () => import('./main/deposit-document/deposit-document.module').then(m => m.DepositDocumentModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'map',
    loadChildren: () => import('./main/map/map.module').then(m => m.MapModule),
    canActivate: [authGuard, permissionGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
